const createEmptyContractor = () => ({
    name: "",
    address: "",
    postalCode: "",
    city: "",
    postOffice: "",
    taxId: "",
    country: {
        id: 0,
        country: "",
        symbol: ""
    }
});

const createEmptyData = () => ({
    id: 0,
    buyer: createEmptyContractor(),
    recipient: createEmptyContractor(),
    invoiceEmail: "",
    lastVerificationDate: null
});

export const clientInvoiceDataStore = {
    state: () => ({
        isLoading: false,
        isSaving: false,
        error: null,
        data: createEmptyData()
    }),
    mutations: {
        setClientInvoiceData(state, data) {
            state.data = data || createEmptyData();
        },
        setClientInvoiceDataLoading(state, status) {
            state.isLoading = status;
        },
        setClientInvoiceDataSaving(state, status) {
            state.isSaving = status;
        },
        setClientInvoiceDataError(state, error) {
            state.error = error;
        },
        resetClientInvoiceData(state) {
            state.data = createEmptyData();
        }
    }
};
